import { Component, OnInit, Input } from '@angular/core';
import { VideoService } from '../../services/video.service';

@Component({
  selector: 'app-video-library',
  templateUrl: './video-library.component.html',
  styleUrls: ['./video-library.component.scss']
})
export class VideoLibraryComponent implements OnInit {

  videoSubjectList : any;

  
  
  constructor(private videoService : VideoService) { 
      
  }

  ngOnInit() {
    this.getAllVideoTopics();
  }


  getAllVideoTopics(){

    this.videoService.getVideoCategory("Subjects").subscribe((resp : any) => {
      this.onVideoSubjectsSucess(resp);
      }, (err) => {
    // Unable to log in
          this.onVideoSubjectsError(err);    
    });
  }


  onVideoSubjectsSucess(resp : any){
    this.videoSubjectList = resp;
  }

  onVideoSubjectsError(err : any){

  }


}
